module.exports = __webpack_public_path__ + "img/car-logo.46e1c5e0.png";